export default {
  common: {
    account: 'アカウント',
    return: '戻る'
  },
  button: {
    returnTop: 'TOPへ戻る',
    rangeSelect: '乗車区間・便を選択する',
    busSelect: 'バスを選ぶ',
    reserveConfirm: '予約を確定する',
    reserveCancel: '予約をキャンセル'
  },
  view: {
    ticket: '乗車券',
    fromAirport: '空港発',
    toAirport: '空港行き',
    directionDep: '出発',
    directionDepDesc: '空港 → 目的地',
    directionArr: '到着',
    directionArrDesc: '目的地 → 空港',
    pleaseSelectBus: 'バスを選んでください',
    availablePeriod: '有効期間',
    useInstruction: '利用説明',
    adultCount: '大人 × {{count}}名',
    childCount: '子供 × {{count}}名',
    disabledAdultCount: '障がい者(大人) × {{count}}名',
    rangeAndSchedule: '乗車区間と乗車日を',
    pleaseSelect: '選択してください',
    ridingDate: '乗車日',
    ridingPlace: '乗車地',
    departurePlace: '出発地',
    arrivalPlace: '到着地',
    company: '運行会社',
    availableSeatsCount: '空席数',
    ridingBusTime: '乗車便',
    buyTicket: '購入済み乗車券',
    reservationRideInfo: '予約情報',
    inReserve: '予約手続き中',
    thankForReservation: 'ご予約ありがとうございます。',
    reservationConfirmed: '下記の内容でご予約が確定しました。',
    inCancel: 'キャンセル手続き中',
    cancelInfo: 'キャンセル情報',
    isCanceled: 'ご予約をキャンセルしました。',
    notAvailableBus: '選択した区間または乗車日は利用できるバスがありません。',
    currentJapanTime: '現在の日本時間: {{time}}',
    baseJapanTime: '下記の時間は日本時間です。',
    remainsCount: '残席数'
  }
};
